import { Space } from '@ably/spaces';
import { ErrorInfo } from 'ably';

const AblyHelpers = {
    enterable: (space?: Space) => {
        const channelState = space?.channel.state;

        return ['initialized', 'attaching', 'attached'].includes(channelState || '');
    },

    log: (identifier: string, channelError: ErrorInfo | null, connectionError: ErrorInfo | null) => {
        const errors = [channelError, connectionError].filter((error): error is ErrorInfo => error != null);

        if (errors.every((error) => error.code === 80017)) {
            return;
        }

        console.warn(
            `Ably ${identifier} Error`,
            JSON.stringify({
                channelError,
                connectionError,
            }),
        );
    },
};

export { AblyHelpers };
